var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Newgrounds } from "../../../external/newgrounds/newgroundsio.min";
export class Achievement {
    constructor() {
        window.achievement = this;
        if (!document.getElementById("newgrounds-login")) {
            const button = document.body.appendChild(document.createElement("button"));
            button.id = "newgrounds-login";
            button.style.position = "absolute";
            button.style.bottom = "5px";
            button.style.right = "5px";
            button.style.height = "24px";
            button.style.fontSize = "10pt";
            button.style.zIndex = "1000";
            button.classList.add("button");
            button.style.display = "none";
            button.innerText = "login newgrounds";
            button.addEventListener("click", (e) => {
                this.requestLogin();
                e.stopPropagation();
            });
        }
    }
    loginCheck(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const ngio = yield this.getNg(credentials);
            if (!(ngio === null || ngio === void 0 ? void 0 : ngio.user)) {
                console.log("Not logged into newgrounds.");
                const button = document.getElementById("newgrounds-login");
                if (button) {
                    //        button.style.display = "";
                }
            }
            else {
                this.onLoggedIn(ngio);
            }
        });
    }
    onLoggedIn(ngio) {
        var _a, _b, _c;
        const img = document.body.appendChild(document.createElement("img"));
        img.style.position = "absolute";
        img.style.width = "25px";
        img.style.height = "25px";
        img.style.right = "5px";
        img.style.bottom = "5px";
        img.src = (_b = (_a = ngio.user) === null || _a === void 0 ? void 0 : _a.icons.small) !== null && _b !== void 0 ? _b : "";
        setTimeout(() => {
            img.style.display = "none";
        }, 1000);
        console.log("Welcome", ((_c = ngio.user) === null || _c === void 0 ? void 0 : _c.name) + "!");
    }
    requestLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.credentials) {
                return;
            }
            const ngio = yield this.getNg(this.credentials);
            ngio === null || ngio === void 0 ? void 0 : ngio.requestLogin(() => this.onLoggedIn(ngio), () => this.onLoginFailed(ngio), () => this.onLoginCancelled());
            const button = document.getElementById("newgrounds-login");
            if (button) {
                button.style.display = "none";
            }
        });
    }
    onLoginFailed(ngio) {
        var _a;
        console.log("There was a problem logging in: ", (_a = ngio === null || ngio === void 0 ? void 0 : ngio.login_error) === null || _a === void 0 ? void 0 : _a.message);
        const button = document.getElementById("newgrounds-login");
        if (button) {
            button.style.display = "";
        }
    }
    onLoginCancelled() {
        console.log("The user cancelled the login.");
        const button = document.getElementById("newgrounds-login");
        if (button) {
            button.style.display = "";
        }
    }
    getNg(credentials) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (credentials.key !== ((_a = this.credentials) === null || _a === void 0 ? void 0 : _a.key) || credentials.secret !== ((_b = this.credentials) === null || _b === void 0 ? void 0 : _b.secret)) {
                this.credentials = Object.assign({}, credentials);
                this.ng = new Newgrounds.io.core(this.credentials.key, this.credentials.secret);
                return new Promise(resolve => { var _a; return (_a = this.ng) === null || _a === void 0 ? void 0 : _a.getValidSession(() => resolve(this.ng)); });
            }
            return Promise.resolve(this.ng);
        });
    }
    getMedals(ngio) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.medals) {
                return this.medals;
            }
            if (!ngio) {
                return [];
            }
            return new Promise(resolve => {
                ngio === null || ngio === void 0 ? void 0 : ngio.callComponent("Medal.getList", {}, result => {
                    this.medals = result.medals;
                    resolve(result.medals);
                });
            });
        });
    }
    unlock({ credentials, medalName }) {
        return __awaiter(this, void 0, void 0, function* () {
            const allMedals = yield this.getMedals(yield this.getNg(credentials));
            const [medal] = allMedals.filter(medal => medal.name === medalName);
            const ngio = yield this.getNg(credentials);
            return new Promise((resolve) => {
                if (medal.unlocked) {
                    resolve({ medal, justUnlocked: false });
                }
                ngio === null || ngio === void 0 ? void 0 : ngio.callComponent("Medal.unlock", { id: medal === null || medal === void 0 ? void 0 : medal.id }, (result) => {
                    console.log(result);
                    resolve({ medal: result.medal, justUnlocked: true });
                });
            });
        });
    }
    fetchScoreboards(ngio, callback) {
        if (this.scoreboards) {
            callback === null || callback === void 0 ? void 0 : callback(this.scoreboards);
        }
        else {
            ngio === null || ngio === void 0 ? void 0 : ngio.callComponent("ScoreBoard.getBoards", {}, (result) => {
                var _a;
                if (result.success) {
                    this.scoreboards = result.scoreboards;
                    (_a = this.scoreboards) === null || _a === void 0 ? void 0 : _a.forEach((scoreboard) => console.log("Scoreboard:", scoreboard.name, scoreboard.id));
                }
            });
        }
    }
    postNGScore(ngio, value, callback) {
        this.fetchScoreboards(ngio, (scoreboards) => {
            const scoreboard = scoreboards[0];
            ngio === null || ngio === void 0 ? void 0 : ngio.callComponent("ScoreBoard.postScore", { id: scoreboard.id, value }, callback !== null && callback !== void 0 ? callback : ((result) => { }));
        });
    }
    postScore({ credentials, value }) {
        return __awaiter(this, void 0, void 0, function* () {
            const ngio = yield this.getNg(credentials);
            return new Promise((resolve) => {
                this.postNGScore(ngio, value, () => resolve());
            });
        });
    }
}
